// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import {ResourcesConfig} from 'aws-amplify';

import {ENV} from '@/constants/EnvConstants';

export const awsAmplifyConfiguration: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: ENV.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: ENV.VITE_COGNITO_USER_POOL_CLIENT_ID,
    },
  },
};
